import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';

const AUTO_DISMISS_MS = 10000;

@Component({
  selector: 'app-declaration-draft-notice',
  templateUrl: './declaration-draft-notice.component.html',
  styleUrls: ['./declaration-draft-notice.component.scss']
})
export class DeclarationDraftNoticeComponent implements OnChanges, OnDestroy {
  @Input() show = false;
  @Output() dismissed = new EventEmitter<void>();

  private autoDismissTimer: ReturnType<typeof setTimeout> | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['show'] && this.show) {
      this.restartAutoDismissTimer();
    }
  }

  ngOnDestroy(): void {
    this.clearAutoDismissTimer();
  }

  onClose(): void {
    this.clearAutoDismissTimer();
    this.dismissed.emit();
  }

  private restartAutoDismissTimer(): void {
    this.clearAutoDismissTimer();
    this.autoDismissTimer = setTimeout(() => this.onClose(), AUTO_DISMISS_MS);
  }

  private clearAutoDismissTimer(): void {
    if (this.autoDismissTimer) {
      clearTimeout(this.autoDismissTimer);
      this.autoDismissTimer = null;
    }
  }
}
